export const LOGIN_FORM_TYPE = "login";
export const RE_AUTHENTICATION_FORM_TYPE = "reAuthentication";
export const MFA_FORM_TYPE = "MFA_FORM_TYPE";
